/**
 * @generated SignedSource<<88b5fc91625b83d33bb92cea8b809990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastPickerButton_dashboard$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "StorecastPickerButton_dashboard";
};
export type StorecastPickerButton_dashboard$key = {
  readonly " $data"?: StorecastPickerButton_dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerButton_dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastPickerButton_dashboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "a8d0c39816e7cfa56a44bcee0eb0ff8a";

export default node;
